export * from "../global/ui-quiz";
